/**
 * Shared Clerk `appearance` config so SignIn/SignUp don't look like a SaaS
 * dashboard dropped into HandInvoice's industrial dark theme.
 *
 * Two-layer strategy:
 * - `variables` + `elements` here cover all the static styling.
 * - `index.css` carries `!important` overrides for the few states this API
 *   can't express (focus glows, hover, placeholder color) AND for elements
 *   where Clerk's per-provider branding (Google's "Last used" pill, etc.)
 *   re-injects styles after ours land.
 */
export const handinvoiceClerkAppearance = {
  variables: {
    colorPrimary: "#e8dc2d",
    colorBackground: "#1a1917",
    colorText: "#f4f1ea",
    colorTextSecondary: "#a8a29a",
    colorInputBackground: "#0f0e0c",
    colorInputText: "#f4f1ea",
    colorDanger: "#e8634a",
    colorSuccess: "#6fc96f",
    colorNeutral: "#a8a29a",
    fontFamily: "'Inter', system-ui, sans-serif",
    fontFamilyButtons: "'Inter', system-ui, sans-serif",
    borderRadius: "10px",
  },
  elements: {
    card: {
      backgroundColor: "#1a1917",
      border: "1px solid #3a362e",
      boxShadow: "0 24px 60px -18px rgba(0,0,0,0.6)",
      color: "#f4f1ea",
    },
    headerTitle: {
      fontFamily: "'Instrument Serif', Georgia, serif",
      fontStyle: "italic",
      fontSize: 22,
      color: "#f4f1ea",
    },
    headerSubtitle: {
      color: "#a8a29a",
    },
    socialButtonsBlockButton: {
      backgroundColor: "#0f0e0c",
      border: "1px solid #3a362e",
      color: "#f4f1ea",
    },
    socialButtonsBlockButtonText: {
      color: "#f4f1ea",
      fontWeight: 600,
    },
    dividerLine: {
      backgroundColor: "#3a362e",
    },
    dividerText: {
      color: "#5c584f",
      fontFamily: "'JetBrains Mono', ui-monospace, monospace",
      fontSize: 10,
      letterSpacing: "0.18em",
      textTransform: "uppercase",
    },
    formFieldLabel: {
      color: "#a8a29a",
    },
    formFieldInput: {
      backgroundColor: "#0f0e0c",
      border: "1px solid #3a362e",
      color: "#f4f1ea",
    },
    formFieldHintText: {
      color: "#8a8472",
    },
    formFieldErrorText: {
      color: "#e8634a",
    },
    formButtonPrimary: {
      backgroundColor: "#e8dc2d",
      color: "#0f0e0c",
      fontWeight: 800,
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      fontSize: 12,
    },
    identityPreview: {
      backgroundColor: "#0f0e0c",
      border: "1px solid #3a362e",
      color: "#f4f1ea",
    },
    identityPreviewText: {
      color: "#f4f1ea",
    },
    identityPreviewEditButton: {
      color: "#e8dc2d",
    },
    formResendCodeLink: {
      color: "#e8dc2d",
    },
    otpCodeFieldInput: {
      backgroundColor: "#0f0e0c",
      border: "1px solid #3a362e",
      color: "#f4f1ea",
    },
    footer: {
      backgroundColor: "#1a1917",
    },
    footerActionText: {
      color: "#a8a29a",
    },
    footerActionLink: {
      color: "#e8dc2d",
    },
    alertText: {
      color: "#ffb3ab",
    },
  },
};
